import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Navigate, Outlet } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import ArticlePage from './ArticlePage';
import NewsPage from './NewsPage';
import PresentationPage from './PresentationPage';
import PressKitPage from './PressKitPage';
import CookieBanner from './CookieBanner';

function PublicLayout() {
  return (
    <>
      <Outlet />
      <CookieBanner />
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [
      { path: '/', element: <App /> },
      { path: '/news', element: <NewsPage /> },
      { path: '/news/:slug', element: <ArticlePage /> },
      { path: '/press-kit', element: <PressKitPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
  { path: '/publisher', element: <PresentationPage /> },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);
